import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Flex, Link as ChakraLink, Text } from '@abb/uikit';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import AbbBusinessIcon from 'shared-components/icons/AbbBusinessIcon';
import ABBMarketIcon from 'shared-components/icons/ABBMarketIcon';
import BeyondBankingIcon from 'shared-components/icons/BeyondBankingIcon';
import { InternetBankingIcon } from 'shared-components/icons/internet-banking-icon';
import InvestmentIcon from 'shared-components/icons/InvestmentIcon';
export const Products = ()=>{
    const { t, i18n } = useTranslation('common');
    return /*#__PURE__*/ _jsx(Box, {
        children: /*#__PURE__*/ _jsxs(Flex, {
            p: "0 4px 8px",
            overflowX: "auto",
            width: "100%",
            gap: 2,
            children: [
                /*#__PURE__*/ _jsx(Box, {
                    as: Link,
                    to: "/trade-platform",
                    children: /*#__PURE__*/ _jsxs(Flex, {
                        alignItems: "center",
                        p: 2,
                        gap: 2,
                        children: [
                            /*#__PURE__*/ _jsx(ABBMarketIcon, {}),
                            /*#__PURE__*/ _jsx(Text, {
                                fontSize: "14px",
                                minW: "90px",
                                children: t('menu.digital_bridge.trade_platform')
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ _jsx(Box, {
                    as: Link,
                    to: "/",
                    children: /*#__PURE__*/ _jsxs(Flex, {
                        alignItems: "center",
                        p: 2,
                        gap: 2,
                        children: [
                            /*#__PURE__*/ _jsx(InternetBankingIcon, {}),
                            /*#__PURE__*/ _jsx(Text, {
                                fontSize: "14px",
                                minW: "90px",
                                children: t('menu.digital_bridge.internet_bank')
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ _jsx(Box, {
                    as: Link,
                    to: "/bank-plus",
                    children: /*#__PURE__*/ _jsxs(Flex, {
                        alignItems: "center",
                        p: 2,
                        gap: 2,
                        children: [
                            /*#__PURE__*/ _jsx(BeyondBankingIcon, {}),
                            /*#__PURE__*/ _jsx(Text, {
                                fontSize: "14px",
                                minW: "90px",
                                children: t('menu.digital_bridge.beyond_bank')
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ _jsx(Box, {
                    as: ChakraLink,
                    href: `digital-platform/${i18n.language}/b2b`,
                    children: /*#__PURE__*/ _jsxs(Flex, {
                        alignItems: "center",
                        p: 2,
                        gap: 2,
                        children: [
                            /*#__PURE__*/ _jsx(AbbBusinessIcon, {}),
                            /*#__PURE__*/ _jsx(Text, {
                                fontSize: "14px",
                                minW: "90px",
                                children: t('menu.digital_bridge.open_api')
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ _jsx(Box, {
                    as: Link,
                    to: "/invest",
                    children: /*#__PURE__*/ _jsxs(Flex, {
                        alignItems: "center",
                        p: 2,
                        gap: 2,
                        children: [
                            /*#__PURE__*/ _jsx(InvestmentIcon, {}),
                            /*#__PURE__*/ _jsx(Text, {
                                fontSize: "14px",
                                minW: "90px",
                                children: t('menu.digital_bridge.invest')
                            })
                        ]
                    })
                })
            ]
        })
    });
};
